import { createRoot } from 'react-dom/client';

// scroll bar
import 'simplebar-react/dist/simplebar.min.css';

// apex-chart
import 'assets/third-party/react-table.css';

import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/700.css';

// project imports
import App from './App';
import { ConfigProvider } from 'contexts/ConfigContext';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container);

// ==============================|| JWT FETCH INTERCEPTOR ||============================== //

const originalFetch = window.fetch;
window.fetch = async (...args) => {
  let [resource, config] = args;

  const isStringResource = typeof resource === 'string';
  const isApiCall = isStringResource && resource.startsWith(import.meta.env.VITE_APP_API_URL);
  const isPublicEndpoint =
    isStringResource &&
    (resource.includes('/login') || resource.includes('/forgot-password') || resource.includes('/perusahaan') || resource.includes('/aplikasi'));

  const isAuthPage = window.location.pathname === '/login' || window.location.pathname === '/register' || window.location.pathname === '/forgot-password';

  if (isApiCall && !isPublicEndpoint) {
    const rawAuthUser = localStorage.getItem('auth_user');
    const rawToken = localStorage.getItem('token');
    let userHasAuth = false;
    let tokenToUse = rawToken;

    if (rawAuthUser) {
      userHasAuth = true;
      try {
        const parsed = JSON.parse(rawAuthUser);
        if (parsed && parsed.token) {
          tokenToUse = parsed.token;
        }
      } catch (e) {
        // ignore parse error
      }
    }

    if (rawToken) {
      userHasAuth = true;
    }

    if (tokenToUse) {
      config = config || {};
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${tokenToUse}`
      };
      args[1] = config;
    }

    // Redirect if no auth is found and not on auth page
    if (!userHasAuth && !isAuthPage) {
      localStorage.removeItem('auth_user');
      localStorage.removeItem('token');
      window.location.href = '/login';
      return Promise.reject(new Error('No auth user'));
    }
  }

  try {
    const response = await originalFetch(resource, config);

    if (response.status === 401 && !resource.includes('/login') && !isAuthPage) {
      console.warn('Unauthorized API call (401):', resource);
      // Keep auth_user so user stays logged in even if an API endpoint returns 401
    }

    return response;
  } catch (error) {
    // Log network/connection error without kicking user out
    console.error('Fetch interceptor error:', error);
    throw error;
  }
};

// ==============================|| MAIN - REACT DOM RENDER ||============================== //

root.render(
  <ConfigProvider>
    <App />
  </ConfigProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
